// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"5af5c858","764":"786915e9"}[chunkId] + ".chunk.css";
};